// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  min-height: 100vh;
  background-color: #f0f7f0;
  padding: 2rem;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.dashboard-header h1 {
  color: #2c5530;
  font-size: 2rem;
  margin: 0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-name {
  color: #4a6b4d;
  font-weight: 500;
}

.user-avatar {
  width: 40px;
  height: 40px;
  background-color: #4caf50;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.dashboard-content {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 2rem;
  align-items: start;
}

.courses-section h2 {
  color: #2c5530;
  margin-bottom: 1.5rem;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.course-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.course-image {
  height: 160px;
  overflow: hidden;
}

.course-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.course-info {
  padding: 1.5rem;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.course-info h3 {
  color: #2c5530;
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
}

.course-description {
  color: #4a6b4d;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  line-height: 1.4;
  flex: 1 1;
}

.course-meta {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.duration, .level {
  font-size: 0.8rem;
  color: #4a6b4d;
  background-color: #e8f3e8;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
}

.course-progress {
  margin-top: auto;
}

.progress-bar {
  height: 6px;
  background-color: #e8f3e8;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-fill {
  height: 100%;
  background-color: #4caf50;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 0.8rem;
  color: #4a6b4d;
}

.dashboard-sidebar {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  position: sticky;
  top: 2rem;
}

.progress-summary, .recent-activity {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: fit-content;
}

.progress-summary h3, .recent-activity h3 {
  color: #2c5530;
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
}

.progress-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.stat-item {
  text-align: center;
}

.stat-value {
  display: block;
  font-size: 1.5rem;
  font-weight: 600;
  color: #4caf50;
  margin-bottom: 0.25rem;
}

.stat-label {
  font-size: 0.8rem;
  color: #4a6b4d;
}

.activity-list {
  color: #4a6b4d;
  font-size: 0.9rem;
}

.no-activity {
  text-align: center;
  color: #4a6b4d;
  font-style: italic;
}

@media (max-width: 1024px) {
  .dashboard-content {
    grid-template-columns: 1fr;
  }

  .dashboard-sidebar {
    order: -1;
    position: static;
  }
}

@media (max-width: 768px) {
  .dashboard {
    padding: 1rem;
  }

  .courses-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .user-info {
    width: 100%;
    justify-content: flex-end;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,qDAAqD;EACrD,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":[".dashboard {\n  min-height: 100vh;\n  background-color: #f0f7f0;\n  padding: 2rem;\n}\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.dashboard-header h1 {\n  color: #2c5530;\n  font-size: 2rem;\n  margin: 0;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.user-name {\n  color: #4a6b4d;\n  font-weight: 500;\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  background-color: #4caf50;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.dashboard-content {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 2rem;\n  align-items: start;\n}\n\n.courses-section h2 {\n  color: #2c5530;\n  margin-bottom: 1.5rem;\n}\n\n.courses-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.course-card {\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.course-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.course-image {\n  height: 160px;\n  overflow: hidden;\n}\n\n.course-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.course-info {\n  padding: 1.5rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.course-info h3 {\n  color: #2c5530;\n  margin: 0 0 0.5rem 0;\n  font-size: 1.25rem;\n}\n\n.course-description {\n  color: #4a6b4d;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.course-meta {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.duration, .level {\n  font-size: 0.8rem;\n  color: #4a6b4d;\n  background-color: #e8f3e8;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n}\n\n.course-progress {\n  margin-top: auto;\n}\n\n.progress-bar {\n  height: 6px;\n  background-color: #e8f3e8;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.progress-fill {\n  height: 100%;\n  background-color: #4caf50;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  font-size: 0.8rem;\n  color: #4a6b4d;\n}\n\n.dashboard-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  position: sticky;\n  top: 2rem;\n}\n\n.progress-summary, .recent-activity {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: fit-content;\n}\n\n.progress-summary h3, .recent-activity h3 {\n  color: #2c5530;\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n}\n\n.progress-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-value {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #4caf50;\n  margin-bottom: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.8rem;\n  color: #4a6b4d;\n}\n\n.activity-list {\n  color: #4a6b4d;\n  font-size: 0.9rem;\n}\n\n.no-activity {\n  text-align: center;\n  color: #4a6b4d;\n  font-style: italic;\n}\n\n@media (max-width: 1024px) {\n  .dashboard-content {\n    grid-template-columns: 1fr;\n  }\n\n  .dashboard-sidebar {\n    order: -1;\n    position: static;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard {\n    padding: 1rem;\n  }\n\n  .courses-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dashboard-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .user-info {\n    width: 100%;\n    justify-content: flex-end;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
